import * as ng from 'angular';
import * as Linq from 'linq-es5';
import { ComponentRegistration } from '../../core';
let template = require('./standard-grid.html');


class StandardGridComponent extends ComponentRegistration {

    constructor() {
        super('standardGrid', {
            controller: StandardGridController,
            templateUrl: template,
            transclude: true,
            controllerAs: 'vm',
            bindings: {
                data: '<?',
                getColumns: '&columns',
                totalResults: "<?",
                criteria: "<?",
                criteriaChanged: "&",
                autoColumnWidth: '&',
                loading: '<?',
                columnResize: "<?",
                rowSelection: '<?',
                onRowSelect: '&',
                title: '@?',
                cardDepth: '<?',
                disableSearch: '<?',
                disableHeader: '<?',
                disableAdd: '<?',
                cardStyle: '@?',
                onAdd: '&',
                rowKey: '@',
                selectedKey: '<?'
            }
        });
    }
}

let StandardColumnDirective = {
    name: "stdColumn",
    factory: function () {
        return {
            restrict: 'E',
            transclude: true,
            scope: {
            },
            link: StandardColumnLink,
            controller: StandardColumnController
        };
    }
};

function StandardColumnLink(scope, elem, attrs) {

    var castToCorrectType = (val) => {
        if (val === null || val === undefined && typeof val === 'string') {
            return val;
        }

        if (!isNaN(val)) {
            if (val % 1 === 0)
                return parseInt(val);
            else return parseFloat(val);
        }

        var lowerVal = val.toLowerCase();
        if (lowerVal === 'true') return true;
        if (lowerVal === 'false') return false;

        return val;
    }

    var columnDef = {};
    ng.forEach(attrs.$attr, (value, name) => {
        columnDef[name] = castToCorrectType(attrs[name]);
    });

    ng.extend((scope as any).columnDef, columnDef);
}


class StandardColumnController {

    private static $inject = ['$scope', '$transclude'];
    private transcludedScope: ng.IScope;

    constructor(
        private $scope: ng.IScope,
        private $transclude: ng.ITranscludeFunction) {
    }

    public $onInit() {

        var col = {
            cellTemplate: undefined,
            headerCellTemplate: undefined
        };

        this.$transclude((transEl, transScope) => {
            ng.forEach(transEl, (elem, index) => {
                if (elem.tagName) {
                    if (elem.tagName.toUpperCase() === 'CELL-TEMPLATE') {
                        col.cellTemplate = elem.innerHTML.trim() || undefined;
                    }
                    else if (elem.tagName === 'HEADER-TEMPLATE') {
                        col.headerCellTemplate = elem.innerHTML.trim() || undefined;
                    }
                }
            });

            (this.$scope as any).columnDef = col;
            (this.$scope.$parent as any).columnDefs.push((this.$scope as any).columnDef);
        });

        this.$scope.$on("destroy", () => {
            (this.$scope.$parent as any).columnDefs = undefined;
            (this.$scope as any).columnDef = undefined;
        });
    }



}

class StandardGridController {
    private static $inject: Array<string> = ['$scope', '$templateCache', '$transclude', '$timeout'];
    private gridOptions: any = { data: [] };
    private transcludedScope: any;
    private gridId: number = Math.abs(Math.random());
    private onRowSelect: Function;
    private onAdd: Function;
    private rowSelection: any;
    private criteriaChanged: Function;
    private loading: boolean = false;
    private columnResize: boolean = false;
    private activated: boolean = false;
    private criteria: any;
    private totalResults: number = 0;
    private getColumns: Function;
    private defaultPageSizes: Array<number> = [25, 30];
    private _pageSizes: Array<number> = this.defaultPageSizes;
    private title: string;
    private allPagesDownloaded: boolean = false;
    private cardDepth: number;
    private disableSearch: boolean;
    private disableHeader: boolean;
    private disableAdd: boolean;
    private cardStyle: string;
    private selectedRow: any;
    constructor(private $scope: ng.IScope,
        private $templateCache: ng.ITemplateCacheService,
        private $transclude: ng.ITranscludeFunction,
        private $timeout: ng.ITimeoutService) {
    }


    public $onInit() {

        this.title = this.title || "";
        this.cardDepth = this.cardDepth || 5;
        this.cardStyle = this.cardStyle || "";
        this.rowSelection = ng.isDefined(this.rowSelection) ? this.rowSelection : false;
        this.criteria = this.criteria || { pageSize: 25, pageNumber: 1 };
        this.$transclude((transEl, transScope) => {
            this.transcludedScope = transScope;
            this.transcludedScope.columnDefs = [];
        });


        var columns = this.getColumns() || this.transcludedScope.columnDefs;

        this.gridOptions = {
            infiniteScrollRowsFromEnd: 5,
            //infiniteScrollUp: true,
            //infiniteScrollDown: true,
            useExternalSorting: true,
            enableColumnMenus: false,
            enablePaginationControls: false,
            enableRowHeaderSelection: false,
            multiSelect: false,
            enableRowSelection: this.rowSelection,
            enableColumnResizing: this.columnResize,
            virtualizationThreshold: 51,
            columnDefs: columns,
            onRegisterApi: (gridApi) => {
                let self = this;
                gridApi.infiniteScroll.on.needLoadMoreData(this.$scope, () => {
                    self.getDataDown();
                });
                gridApi.infiniteScroll.on.needLoadMoreDataTop(this.$scope, () => {
                    self.getDataUp();
                });

                (this.$scope as any).gridApi = gridApi;
                gridApi.core.handleWindowResize();

                gridApi.grid.appScope = this.$scope.$parent;
                gridApi.core.on.rowsRendered(this.$scope, (gridScope) => {
                    this.resizeColumnsToContent(gridScope.grid);
                });

                gridApi.core.on.sortChanged(this.$scope, (grid, sortColumns) => {

                    var lastCriteria = ng.copy(this.criteria);

                    var args = {
                        cancel: () => {
                            grid.resetColumnSorting();
                            if (lastCriteria && lastCriteria.SortBy) {
                                var col = Linq.From(grid.columns)
                                    .FirstOrDefault((x: any) => {
                                        return x.field == lastCriteria.SortBy;
                                    }) as any;

                                if (col) {
                                    col.sort.direction = (lastCriteria.SortDirection === 'DESC')
                                        ? 'desc'
                                        : 'asc';
                                }
                            }
                        }
                    };

                    this.raiseCriteriaChanged(args);

                    if (sortColumns.length == 0) {

                        this.criteria.sort = [];
                        this.criteria.SortDirection = 'ASC';
                        this.criteria.SortBy = '';
                    } else {

                        this.criteria.Sort = [{
                            key: sortColumns[0].colDef.field,
                            direction: (sortColumns[0].sort.direction === 'desc')
                                ? 'DESC'
                                : 'ASC'
                        }];

                        this.criteria.SortDirection = this.criteria.Sort[0].direction;
                        this.criteria.SortBy = this.criteria.Sort[0].key;
                        this.allPagesDownloaded = false;
                        this.criteria.pageNumber = 1;
                        this.gridOptions.data = [];
                    }

                });

                gridApi.selection.on.rowSelectionChanged(this.$scope, (row) => {
                    if (this.onRowSelect) {
                        if (row && row.isSelected) {
                            this.selectedRow = row;
                            this.onRowSelect({ selectedRow: row });
                        }
                        else {
                            this.selectedRow = undefined;
                            this.onRowSelect({ selectedRow: undefined });
                        }
                    }
                });

            }
        };

        this.$templateCache.put('ui-grid/uiGridHeaderCell',
            "<div role=\"columnheader\" ng-class=\"{ 'sortable': sortable }\" ui-grid-one-bind-aria-labelledby-grid=\"col.uid + '-header-text ' + col.uid + '-sortdir-text'\" aria-sort=\"{{col.sort.direction == asc ? 'ascending' : ( col.sort.direction == desc ? 'descending' : (!col.sort.direction ? 'none' : 'other'))}}\"><div role=\"button\" tabindex=\"0\" class=\"ui-grid-cell-contents ui-grid-header-cell-primary-focus\" col-index=\"renderIndex\" title=\"TOOLTIP\"><span class=\"ui-grid-header-cell-label\" ui-grid-one-bind-id-grid=\"col.uid + '-header-text'\">{{ col.displayName CUSTOM_FILTERS }}</span> <span ui-grid-one-bind-id-grid=\"col.uid + '-sortdir-text'\" ui-grid-visible=\"col.sort.direction\" aria-label=\"{{getSortDirectionAriaLabel()}}\"><i class=\"glyphicon \" ng-class=\"{ 'glyphicon-chevron-up': col.sort.direction == asc, 'glyphicon-chevron-down': col.sort.direction == desc, 'ui-grid-icon-blank': !col.sort.direction }\" title=\"{{isSortPriorityVisible() ? i18n.headerCell.priority + ' ' + ( col.sort.priority + 1 )  : null}}\" aria-hidden=\"true\"></i> <sub ui-grid-visible=\"isSortPriorityVisible()\" class=\"ui-grid-sort-priority-number\">{{col.sort.priority + 1}}</sub></span></div><div role=\"button\" tabindex=\"0\" ui-grid-one-bind-id-grid=\"col.uid + '-menu-button'\" class=\"ui-grid-column-menu-button\" ng-if=\"grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false\" ng-click=\"toggleMenu($event)\" ng-class=\"{'ui-grid-column-menu-button-last-col': isLastCol}\" ui-grid-one-bind-aria-label=\"i18n.headerCell.aria.columnMenuButtonLabel\" aria-haspopup=\"true\"><i class=\"ui-grid-icon-angle-down\" aria-hidden=\"true\">&nbsp;</i></div><div ui-grid-filter></div></div>");

        this.$templateCache.put('ui-grid/ui-grid-row',
            "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'ui-grid-row-header-cell': col.isRowHeader}\" md-colors=\"{ background: '{{row.isSelected ? \'default-primary-200\' : \'grey-A100\' }}' }\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"
        );



    }

    public $onChanges(model) {


        return;
    }


    private _selectedKey: string;
    private rowKey: string;
    private keyedRowSelected: boolean;

    public get selectedKey() {
        return this._selectedKey;
    }

    public set selectedKey(val: string) {          
        if (val && this._selectedKey !== val) {
            this._selectedKey = val;
            this.keyedRowSelected = false;
            this.selectRow(val);
        }
    }

    private selectRow(key?: string): void  {
        if (this.keyedRowSelected === false) {
            var key = key || this.selectedKey;
            if (key) {
                if (this.$scope) {
                    var gridApi = (this.$scope as any).gridApi;
                    var hasData = this.data && (this.data as Array<any>).length > 0;
                    if (gridApi && hasData) {
                        var index = (this.data as Array<any>)
                            .findIndex(x => x[this.rowKey] === key);

                        if (index >= 0) {
                            gridApi.grid.modifyRows(this.data);
                            gridApi.selection.selectRow(this.data[index]);
                            this.keyedRowSelected = true;
                        }
                    }
                }
            }
        }
    }


    public get data(): any {
        this.gridOptions = this.gridOptions || { data: [] };
        return this.gridOptions.data;
    }

    public set data(val) {

        if (this.criteria && (!this.criteria.pageNumber || this.criteria.pageNumber <= 1)) {
            this.gridOptions.data = [];
            this.allPagesDownloaded = false;
            if ((this.$scope as any).gridApi)
                (this.$scope as any).gridApi.infiniteScroll.resetScroll(true, true)
        }
        if (val && val.length > 0) {

            this.gridOptions = this.gridOptions || { data: [] };
            this.gridOptions.data = this.gridOptions.data.concat(val);
            this.selectRow();
            if (this.$scope && val && val.length >= this.criteria.pageSize) {
                (this.$scope as any).gridApi.infiniteScroll.dataLoaded(false, true);
            } else {
                this.allPagesDownloaded = true;
                (this.$scope as any).gridApi.infiniteScroll.dataLoaded(false, false);
            }
        }
    }

    public get pageSizes() {
        return this._pageSizes;
    }

    public set pageSizes(val) {
        if (val !== this._pageSizes) {
            this._pageSizes = val;
        }

        if (!this._pageSizes || this._pageSizes.length <= 0)
            this._pageSizes = this.defaultPageSizes;
    }

    private getDepthReference(obj, index) { return obj[index] }

    private resizeColumnsToContent(grid) {
        ng.forEach(grid.columns, (col) => {

            //due to the auto column "sizing to content" feature currently not working, 
            //the below code calculates the minimum width needed by first 
            //finding the biggest string in the data per column 
            //(much faster that calculating in the DOM for each value)
            //For the max length string only, calculating out what the presentation size will be
            //only adjust the minimum size if is necessary to grow, and do not shrink
            //this will allow the sizes to start to 
            //stablize as the user pages through the data
            //this function supports ie9+ and all the other browsers

            //for this to work correctly, initial minWidth sizes  must be set
            //to at minimum enough to not truncate the column title Text.
            if (col.visible) {
                let targetId = col.grid.id + '-' + col.uid + '-header-text';
                var headerElem = ng.element(document.getElementById(targetId));
                if (headerElem && headerElem.length > 0) {
                    var max = col.displayName.length;
                    var maxString = col.displayName;
                    var hasData = this.gridOptions.data.length > 0;

                    if (!col.colDef.minWidth)
                        col.colDef.minWidth = this.computeColumnMinWidth(col, maxString, headerElem);

                    if (!col.colDef.initialMinWidth)
                        col.colDef.initialMinWidth = col.colDef.minWidth;

                    //ToDo: limit this loop to only visible data
                    for (var i = 0; i < this.gridOptions.data.length; i++) {
                        var val = col.field.split('.')
                            .reduce(this.getDepthReference, this.gridOptions.data[i]);

                        if (val) {
                            var valString = val.toString();
                            var len = valString.length;
                            if (max < len) {
                                max = len;
                                maxString = valString;
                            }
                        }
                    }

                    if (hasData) {
                        col.colDef.minWidth = this.computeColumnMinWidth(col, maxString, headerElem);
                        col.minWidth = col.colDef.minWidth;
                    }
                }
            }
        });
    }

    private computeColumnMinWidth(column, text, headerElem) {
        var c = document.createElement("canvas");
        c.className = "ui-grid-cell-contents";
        var ctx = c.getContext("2d");

        var computedStyles = window.getComputedStyle(headerElem[0], null);
        var fontSize = computedStyles.getPropertyValue("font-size");
        var fontFamily = computedStyles.getPropertyValue("font-family");
        ctx.font = fontSize + ' ' + fontFamily;
        var newSize = Math.ceil(ctx.measureText(text).width * 1.15);
        return (newSize < column.colDef.initialMinWidth) ? column.colDef.initialMinWidth : newSize;
    }

    private raiseCriteriaChanged(e) {
        if (typeof this.criteriaChanged === 'function') {
            this.criteriaChanged({
                args: {
                    criteria: this.criteria,
                    cancel: e.cancel
                }
            });
        }
    };

    private onSearchEnter(keyIdentifier) {
        if (keyIdentifier === "Enter") {
            this.criteria.pageNumber = 1;
            this.allPagesDownloaded = false;
            this.gridOptions.data = [];
            this.raiseCriteriaChanged({
                cancel: () => {
                }
            });
        }
    }

    private onSearchClick(keyIdentifier) {
        this.criteria.pageNumber = 1;
        this.allPagesDownloaded = false;
        this.gridOptions.data = [];
        this.raiseCriteriaChanged({
            cancel: () => {
            }
        });
    }

    private getDataDown() {
        if (!this.allPagesDownloaded) {
            this.criteria.pageNumber++;
            this.raiseCriteriaChanged({
                cancel: () => {
                }
            });
        }
    }

    private getDataUp() {
        if (this.criteria.pageNumber < 1) {
            this.criteria.pageNumber--;
            this.raiseCriteriaChanged({
                cancel: () => {
                }
            });
        }
    }

    private onAddClick(): void {
        this.raiseAdd();
    }

    private raiseAdd(): void {
        if (this.selectedRow) {
            this.selectedRow.isSelected = false;
            this.selectedRow = undefined;
        }
        if (typeof this.onAdd === 'function') {
            this.onAdd();
        }
    }
}


let sgComponent = new StandardGridComponent();
export { StandardColumnDirective, sgComponent as StandardGridComponent }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/user-controls/grid/standard-grid.ts